import React from "react"

import Popup from "components/Ui/Popup"
import { ActionDot, BranchDot, ConditionDot } from "./NodeToolbar.styled"
import {
  NodeOption,
  NodeOptionIcon,
  NodeOptionLabel,
  NodeOptions
} from "./AddNodeDialog.styled"
import { ACTION, BRANCH, CONDITION } from "../nodeKind"

export type NodeChoice = typeof CONDITION | typeof ACTION | typeof BRANCH

type Props = {
  onSelect: (choice: NodeChoice) => void
  onClose: () => void
}

const AddNodeDialog = ({ onSelect, onClose }: Props) => (
  <Popup
    title="Insert node"
    subtitle="Choose the type of node to add at this position."
    handleCloseClick={(e) => {
      e.stopPropagation()
      onClose()
    }}
    hideOkButton
    cancelButtonText="Cancel"
  >
    <NodeOptions>
      <NodeOption type="button" onClick={() => onSelect(CONDITION)}>
        <NodeOptionIcon>
          <ConditionDot />
        </NodeOptionIcon>
        <NodeOptionLabel>
          <strong>Condition</strong>
          <span>Branch the workflow based on a check.</span>
        </NodeOptionLabel>
      </NodeOption>
      <NodeOption type="button" onClick={() => onSelect(BRANCH)}>
        <NodeOptionIcon>
          <BranchDot />
        </NodeOptionIcon>
        <NodeOptionLabel>
          <strong>Branch</strong>
          <span>Route the workflow into one of many outcomes.</span>
        </NodeOptionLabel>
      </NodeOption>
      <NodeOption type="button" onClick={() => onSelect(ACTION)}>
        <NodeOptionIcon>
          <ActionDot />
        </NodeOptionIcon>
        <NodeOptionLabel>
          <strong>Action</strong>
          <span>Perform an action like cancel, deliver or set state.</span>
        </NodeOptionLabel>
      </NodeOption>
    </NodeOptions>
  </Popup>
)

export default AddNodeDialog
